import sharedConfig, { ENVIRONMENTS } from './shared';

import type { Config } from './env';

const { app, ...shared } = sharedConfig;

const configCatKey = process.env.REACT_APP_BOT_CONFIG_CAT_KEY || '';
const recaptchaSiteKey = process.env.REACT_APP_BOT_RECAPTCHA_SITE_KEY || '';

const configBase = {
  app: {
    ...app,
    catalogName: 'Catálogos dos ciclos',
    name: 'O Boticário',
    slugname: 'boticario',
    gtm: 'GTM-NDRJCD3',
    short: 'bot',
    url: 'https://hrevendedor.boticario.com.br/',
    fallbackUrl: 'https://www.hrevendedor.boticario.com.br/',
    paymentUrl: 'https://www.hrevendedor.boticario.com.br/history',
    paymentVDFUrl: 'https://hrevendedores.grupoboticario.com.br/history',
    mfLink: 'https://hreseller-self-service-mf.eudora.com.br',
  },
  configCat: {
    key: configCatKey,
  },
  prismic: {
    accessToken: '',
    apiUrl: 'https://re-boticario.cdn.prismic.io/api/v2',
  },
  bff: {
    applicationID: '9718661b-2fcf-43da-a8dc-8de0f964167a',
    baseUrl: process.env.REACT_APP_BFF_URL || '',
    clientID: 'JvG3XD29M1zCHQS9WSLC44ahjhTx8Pdi',
  },
  communication: {
    message:
      'Olá, estava no Portal do Revendedor e gostaria de falar com a Central de Atendimento ao Revendedor O Boticário',
    openingHours: 'Atendimento de segunda a sexta das 9h às 18h e sábado das 9h às 16h',
    phone: '',
    phoneNote:
      'Ligação gratuita de qualquer lugar do país tanto de telefone fixo quanto de celular',
    title: 'Central de atendimento ao revendedor',
    userNamingConvention: {
      singular: 'Revendedor',
      plural: 'Revendedores',
    },
    whatsapp: '(41) 8735-7095',
  },
  registration: {
    infoResellerPlace: 'Espaço do Revendedor (ER) e Supervisão',
  },
  starlink: {
    baseUrl: 'https://vd-starlink-assets.grupoboticario.com.br',
  },
  privacyPolicies: {
    title: 'Política de Privacidade',
    site: 'https://privacidade.grupoboticario.com.br/politica-de-privacidade/',
  },
  google: {
    recaptcha: {
      siteKey: recaptchaSiteKey,
    },
  },
  ...shared,
};

if (process.env.NODE_ENV === ENVIRONMENTS.PRODUCTION) {
  configBase.app.url = 'https://revendedor.boticario.com.br/';
  configBase.app.fallbackUrl = 'https://www.revendedor.boticario.com.br/';
  configBase.app.paymentUrl = 'https://www.revendedor.boticario.com.br/history';
  configBase.app.paymentVDFUrl = 'https://revendedores.grupoboticario.com.br/history';
  configBase.app.mfLink = 'https://reseller-self-service-mf.eudora.com.br';
  configBase.bff.clientID = 'y6PFGmg9h5fQ7gEx4QIgmZERVkBxSGKH';
}

const config: Config = {
  ...configBase,
};

export default config;
